"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseMembersV3Service", {
    enumerable: true,
    get: function() {
        return BaseMembersV3Service;
    }
});
const _common = require("@nestjs/common");
const _constants = require("src/constants");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
const _baseusersservice = require("~/services/base-users/base-users.service");
const _helpers = require("~/helpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let BaseMembersV3Service = class BaseMembersV3Service {
    async userList(context, param) {
        const baseUsers = await _models.BaseUser.getUsersList(context, {
            base_id: param.baseId,
            mode: param.mode
        });
        return {
            list: this.builder().build(baseUsers)
        };
    }
    async userInvite(context, param) {
        var _param_baseMembers;
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/BaseMemberCreate', param.baseMembers, true);
        if (((_param_baseMembers = param.baseMembers) == null ? void 0 : _param_baseMembers.length) > _constants.V3_META_REQUEST_LIMIT) {
            _catchError.NcError.get(context).maxPayloadLimitExceeded(_constants.V3_META_REQUEST_LIMIT);
        }
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        const userIds = [];
        try {
            for (const baseUser of param.baseMembers){
                let user;
                let userEmail;
                if ('user_id' in baseUser && baseUser.user_id) {
                    user = await _models.User.get(baseUser.user_id, ncMeta);
                    if (!user) {
                        _catchError.NcError.get(context).userNotFound(baseUser.user_id);
                    }
                    userEmail = user.email;
                } else if ('email' in baseUser && baseUser.email) {
                    user = await _models.User.getByEmail(baseUser.email, ncMeta);
                    userEmail = baseUser.email;
                } else {
                    _catchError.NcError.get(context).invalidRequestBody('Either email or id is required');
                }
                await this.baseUsersService.userInvite(context, {
                    baseId: param.baseId,
                    baseUser: {
                        email: userEmail,
                        roles: baseUser.base_role
                    },
                    req: param.req
                }, ncMeta);
                userIds.push(user.id);
            }
            await ncMeta.commit();
        } catch (e) {
            // on error rollback the transaction and throw the error
            await ncMeta.rollback();
            if (e instanceof _catchError.NcError || e instanceof _catchError.NcBaseError) throw e;
            this.logger.error('Error inviting base members', e);
            _catchError.NcError.get(context).baseUserError('Bad Request');
        }
        return this.builder().build(await _models.BaseUser.getUsersList(context, {
            base_id: param.baseId,
            user_ids: userIds
        }));
    }
    async baseMemberUpdate(context, param) {
        var _param_baseMembers;
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/BaseMemberUpdate', param.baseMembers, true, context);
        if (((_param_baseMembers = param.baseMembers) == null ? void 0 : _param_baseMembers.length) > _constants.V3_META_REQUEST_LIMIT) {
            _catchError.NcError.get(context).maxPayloadLimitExceeded(_constants.V3_META_REQUEST_LIMIT);
        }
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        const userIds = [];
        try {
            for (const baseUser of param.baseMembers){
                const userId = baseUser.user_id;
                userIds.push(userId);
                await this.baseUsersService.baseUserUpdate(context, {
                    baseId: param.baseId,
                    baseUser: {
                        roles: baseUser.base_role
                    },
                    userId,
                    req: param.req
                }, ncMeta);
            }
            await ncMeta.commit();
        } catch (e) {
            // on error rollback the transaction and throw the error
            await ncMeta.rollback();
            this.logger.error('Error updating base members', e);
            _catchError.NcError.get(context).baseUserError('Bad Request');
        }
        return this.builder().build(await _models.BaseUser.getUsersList(context, {
            base_id: param.baseId,
            user_ids: userIds
        }));
    }
    constructor(baseUsersService){
        this.baseUsersService = baseUsersService;
        this.logger = new _common.Logger(BaseMembersV3Service.name);
        this.builder = (0, _apiv3datatransformationbuilder.builderGenerator)({
            allowed: [
                'id',
                'email',
                'name',
                'created_at',
                'updated_at',
                'roles',
                'workspace_roles',
                'workspace_id',
                'display_name'
            ],
            mappings: {
                id: 'user_id',
                roles: 'base_role',
                workspace_roles: 'workspace_role',
                display_name: 'name'
            },
            transformFn (data) {
                if (!data.name) {
                    data.name = undefined;
                }
                return data;
            }
        });
    }
};
BaseMembersV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _baseusersservice.BaseUsersService === "undefined" ? Object : _baseusersservice.BaseUsersService
    ])
], BaseMembersV3Service);
